import React from "react";
import './common.css'; // Import regular CSS

export default function LandingPage() {
  return (
    <div className="container">
      <header className="header">
        <h1 className="logo">Saral Platform</h1>
      </header>

      <section className="intro">
        <h2 className="intro-tagline">Simple AI. Ready to Use. Built for SMBs.</h2>
        <p className="intro-subtitle">APIs · Agents · Automations · CCaaS</p>
      </section>

      <section id="features" className="features">
        <h3>Our services</h3>
        <div className="feature-list">
          <a href="/SaralContact" className="feature-link">
            <div className="feature">
              <div className="feature-icon">🎧</div>
              <h4>Managed CCaaS</h4>
              <p>Transforming from cost centers → experience centers, powered by AI</p>
            </div>
          </a>
          <a href="/SaralModeration" className="feature-link">
            <div className="feature">
              <div className="feature-icon">🛡️</div>
              <h4>Content Moderation</h4>
              <p>Smart content moderation protecting brands, users, and platforms.</p>
            </div>
          </a>
          <a href="/SaralTranslate" className="feature-link">
            <div className="feature">
              <div className="feature-icon">🔍</div>
              <h4>AI Translation</h4>
              <p>Break language barriers with real-time, accurate translation services.</p>
            </div>
          </a>
        </div>
      </section>

      <section id="contact" className="contact">
        <h3>Want to learn more?</h3>
        <p>Email us at <a href="mailto:mandar@saralplatform.com">mandar@saralplatform.com</a></p>
        <p>Call us at <a href="tel:770-378-8627">770-378-8627</a></p>
      </section>

      <footer className="footer">
        &copy; 2025 SaralPlatform. All rights reserved.
      </footer>
    </div>
  );
}
